// TODO: Reduce store responsabilities
import { defineStore } from "pinia";
import MetricsHelper from "../help/metricsHelper";
export const analyticsStore = defineStore("analytics", {
  state: () => ({
    graphFilters: {
      messageEngineSelected: null,
      platformSelected: null,
      countrySelected: null,
      optedInOptedOutBarParams: null,
    },
    queryParams: {
      outboundParams: null,
      inboundParams: null,
      interactionPieParams: null,
      validNumbersPieParams: null,
      validInvalidBarParams: null,
      outboundPieParams: null,
      inboundPieParams: null,
      messageParams: null,
      campaignParams: null,
      kpiParams: null,
    },
    data: {
      outboundMessage: [],
      inboundBarData: [],
      interactionPieData: [],
      optedInOptedOutBarData: [],
      validInvalidBarData: [],
      validPieData: [],
      outboundPieData: [],
      inboundPieData: [],
      messagePieData: [],
      campaignPieData: [],
      personByCityPieData: [],
      inboundTemplatesPieData: [],
      outboundTemplatesPieData: [],
      messageTemplatesPieData: [],
    }
  }),
  actions: {
    setGraphFilters(data) {
      this.graphFilters = data;
    },
    setGraphData(data, graph) {
      const method = MetricsHelper[graph.method];
      const params = this.queryParams[graph.query_params];
      this.data[graph.result] = method(data, graph, params);
    },
    setQueryParams(graphs, programsIds, customParams, customFilters) {
      graphs.forEach(element => {
        let params = Object.assign({}, element.params || element);

        if (programsIds)
          params.instanceIds = programsIds;

        if (customParams)
          Object.assign(params, customParams);

        // Filters
        const filters = [];
        if (customFilters) {
          for (let key in customFilters) {
            const value = customFilters[key];
            if (value && value != 'All')
              filters.push(`${key}=${String(value)}`);
          }
        }
        if (filters.length) {
          Object.assign(params, {
            filters: filters.join(',')
          });
        }
        else {
          delete params.filters;
        }

        const result = [];
        Object.values(this.graphFilters).forEach((filter) => {
          const filterValue = MetricsHelper.buildFilterString(filter);
          result.push(filterValue);
        });

        if (result.some((el) => el !== null)) {
          Object.assign(params, {
            instanceFilters: result.join(",").replace(/,\s*$/, ""),
          });
        }

        this.queryParams[element.query_params] = params;
      });
    }
  }
});
